module.exports = __webpack_public_path__ + "img/DownArrow.e62ffea4.svg";